import richTextUtils from "@plugins/richtext/utils/richtext.utils";
import { isEmpty, isNull } from "@utils/var.check";
import StringUtils from "@utils/string.utils";
import { formatSubjectTitleCase, formatSubjectWordsTitleCase } from "@utils/subject.utils";

export default {
  data() {
    return {
      processedData: {},
      subjectLevelList: [],
    };
  },
  methods: {
    sortResourceTaggingsAndGenerateSubjectLevelList() {
      if (isEmpty(this.processedData?.resourceTaggings)) return;

      let resourceTaggings = this.processedData.resourceTaggings;

      if (isEmpty(resourceTaggings)) {
        return;
      }

      resourceTaggings = resourceTaggings.filter((rt) => !isNull(rt.subjectName)).slice(0, 3);

      if (isEmpty(resourceTaggings)) {
        return;
      }

      // Sort the resourceTaggings array by subjectName and then levelAndStreamName
      resourceTaggings.sort((a, b) => {
        // Sort by subjectName
        const subjectComparison = (a.subjectName || "").localeCompare(b.subjectName || "");
        if (subjectComparison !== 0) {
          return subjectComparison;
        }
        // If subjectName is the same, sort by levelAndStreamName
        return (a.levelAndStreamName || "").localeCompare(b.levelAndStreamName || "");
      });

      for (const tagging of resourceTaggings) {
        if (tagging.subjectName !== null || tagging.levelAndStreamName !== null) {
          const formattedSubjectName = tagging.subjectName
            ? formatSubjectWordsTitleCase(tagging.subjectName)
            : null;

          const pair = {
            subjectKey: tagging.subjectKey,
            subjectName: formattedSubjectName,
            levelAndStreamName: tagging.levelAndStreamName,
            subjectId: tagging.subjectId,
            levelAndStreamId: tagging.levelAndStreamId,
          };

          this.subjectLevelList.push(pair);
        }
      }
      this.processedData.resourceTaggings = resourceTaggings;
    },
    preProcessContentMapSubjectLevelAndStream(data, searchFilters) {
      const sortedSearchArr = [];

      // iterate resource tagging to calculate the score for each tagging
      this.preProcessSubjectLevelAndStream(data.resourceTaggings, sortedSearchArr, searchFilters);

      if (sortedSearchArr.length > 0) {
        // sort in ascending order based on the score
        sortedSearchArr.sort(function (a, b) {
          return a.score > b.score ? 1 : a.score < b.score ? -1 : 0;
        });

        // get the latest tagging with highest score
        const latestTagging = sortedSearchArr[sortedSearchArr.length - 1].value;
        let latestSubject = latestTagging.subjects.find((subject) => {
          return searchFilters.subject.includes(subject.id.toString());
        });
        let latestLevelAndStream = latestTagging.levelAndStreams.find((levelAndStream) => {
          return searchFilters.level.includes(levelAndStream.id.toString());
        });

        if (!isDefined(latestSubject)) {
          latestSubject = latestTagging.subjects[0];
        }

        if (!isDefined(latestLevelAndStream)) {
          latestLevelAndStream = latestTagging.levelAndStreams[0];
        }
        data.latestSubject = latestSubject.subjectName ? latestSubject.subjectName : "";
        data.latestLevelAndStream = latestLevelAndStream ? latestLevelAndStream : "";
        data.latestSubjectKey = latestSubject.subjectKey ? latestSubject.subjectKey : "";
      }
    },
    preProcessSubjectLevelAndStream(resourceTaggings, sortedSearchArr, searchFilters) {
      if (!resourceTaggings || !searchFilters) {
        return false;
      }

      resourceTaggings.forEach((resourceTagging) => {
        let score = 0;

        if (resourceTagging && this.validateResourceTagging(resourceTagging.contentMapMetadata)) {
          if (!isEmpty(resourceTagging.subjects)) {
            resourceTagging.subjects.forEach((subject) => {
              // If subject is match with search filter add 1 score
              if (
                subject.id &&
                searchFilters.subject.length > 0 &&
                searchFilters.subject.indexOf(subject.id.toString()) !== -1
              ) {
                score++;
              }
            });
          }

          if (!isEmpty(resourceTagging.subjects)) {
            resourceTagging.levelAndStreams.forEach((levelAndStream) => {
              // If level and stream is match with search filter add 1 score
              if (
                levelAndStream.id &&
                searchFilters.level.length > 0 &&
                searchFilters.level.indexOf(levelAndStream.id.toString()) !== -1
              ) {
                score++;
              }
            });
          }

          sortedSearchArr.push({ score: score, value: resourceTagging });
        }
      });
    },
    validateResourceTagging(contentMap) {
      if (!contentMap) {
        return true;
      }

      return contentMap.started || contentMap.viewableByTeachers;
    },
    processDescription(description) {
      const formattedDescription = richTextUtils.stripHTML(description);
      return formattedDescription;
    },
  },
  computed: {
    levelAndStreamLabel() {
      if (isEmpty(this.subjectLevelList)) {
        return "";
      }
      return StringUtils.toTitleCaseWithSpecialCharacters(
        this.subjectLevelList[0].levelAndStreamName,
      );
    },
    subjectLabel() {
      if (isEmpty(this.subjectLevelList)) {
        return "";
      }
      return formatSubjectTitleCase(this.subjectLevelList[0].subjectName);
    },
    subjectLabelCode() {
      if (isEmpty(this.subjectLabel)) {
        return "";
      }
      return `${this.subjectLabel} - ${this.subjectLevelList[0].subjectKey}`;
    },
  },
  created() {
    this.processedData = this.resourceData;
  },
};
